<template>
  <div class="mc-videohistory-stream__state mc-videohistory-stream__state--end">
    <div class="wrapper-content">
      <p>{{ $t('trackVideo.videoEnded') }}</p>
      <div class="wrapper-action">
        <b-button size="sm" variant="outline-primary" class="repeat" @click="playStream('repeat')">
          <i class="mc-fa icon-outline_refresh"></i> {{ $t('trackVideo.repeatVideo') }}
        </b-button>
        <b-button variant="primary" size="sm" class="next" @click="playStream('next')">
          <i class="mc-fa icon-outline_rewind-right"></i> {{ $t('trackVideo.nextVideo') }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'
import { mapGetters } from 'vuex'
import { v4 as uuidv4 } from 'uuid'

export default {
  name: 'EndState',
  mixins: [Helper, MixPanel],
  props: {
    isMdvrSleep: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters('vehicle', ['vehicleDetail', 'vehicleId', 'isUsingWsFlv']),
    ...mapGetters({
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    pickVideo() {
      return this.$store.state.vehicle.indexVideoActive
    },
    vehicleVideos() {
      return this.$store.state.vehicle.vehicleVideos
    },
    isVideoDemo() {
      if (!this.$route.query?.vehicleId) return false
      const dataDemoVideoHistory = this.getFeatureFlagValue('vsms2_trackvision2_playback_demo_id')
      return Object.keys(dataDemoVideoHistory).includes(this.$route.query?.vehicleId.toString())
    },
  },
  methods: {
    async playStreamVssHowen(video) {
      this.$store.commit('vehicle/setVideoStatusDetail', 'connecting')
      await this.delay(2000)
      const source = {
        id: this.vehicleDetail.imei,
        startTime: video.startTime.split('T').join(' '),
        endTime: video.endTime.split('T').join(' '),
        channel: video.channel,
        src: '',
      }
      this.$store.commit('vehicle/setSource', source)
      await this.delay(1000)
      this.$store.commit('vehicle/setVideoStatusDetail', 'ready')
    },

    async playStream(type) {
      let index, indexVideo, video
      this.$store.commit('vehicle/setIsVideoHasBeenPaused', false)
      if (type === 'repeat') {
        this.track('Replay video history')
        index = this.pickVideo[0]
        indexVideo = this.pickVideo[1]
        video = this.vehicleVideos[index].videos[indexVideo]
      } else if (type === 'next') {
        if (
          this.pickVideo[0] === this.vehicleVideos.length - 1 &&
          this.pickVideo[1] === this.vehicleVideos[this.pickVideo[0]].videos.length - 1
        ) {
          this.$mcToast.error(this.$t('trackVideo.noNextVideo'))
          return
        }
        if (
          this.pickVideo[0] < this.vehicleVideos.length - 1 &&
          this.pickVideo[1] === this.vehicleVideos[this.pickVideo[0]].videos.length - 1
        ) {
          index = this.pickVideo[0] + 1
          indexVideo = 0
          video = this.vehicleVideos[index].videos[indexVideo]
        }
        if (
          this.pickVideo[0] < this.vehicleVideos.length &&
          this.pickVideo[1] < this.vehicleVideos[this.pickVideo[0]].videos.length - 1
        ) {
          index = this.pickVideo[0]
          indexVideo = this.pickVideo[1] + 1
          video = this.vehicleVideos[index].videos[indexVideo]
        }
      }

      this.$store.commit('vehicle/setSource', null)
      if (this.isMdvrSleep) {
        this.$store.commit('vehicle/setVideoStatusDetail', 'sleep')
      } else {
        this.$store.commit('vehicle/setVideoStatusDetail', 'connecting')
      }
      this.$store.commit('vehicle/setStartTime', video.startTime)

      this.track('Play Streaming Video History')

      if (this.isVideoDemo) {
        this.$store.commit('vehicle/setIndexVideoActive', [index, indexVideo])

        const url =
          process.env.VUE_APP_DEMO_ASSET_URL + '/' + this.vehicleId + '/' + video.mediaFilename

        const source = {
          id: this.vehicleDetail.imei,
          startTime: video.startTime,
          src: url,
        }
        this.$store.commit('vehicle/setSource', source)
        await this.delay(500)
        this.$store.commit('vehicle/setVideoStatusDetail', 'ready')
        return
      }
      const deviceName = this.$store.state.vehicle.vehicleDetail.deviceName
      if (deviceName === 'vss-howen') {
        this.$store.commit('vehicle/setIndexVideoActive', [index, indexVideo])
        return this.playStreamVssHowen(video)
      }
      try {
        const uid = uuidv4()
        const input =
          deviceName === 'jc'
            ? {
                jcInput: {
                  filename: video.mediaFilename,
                },
              }
            : {
                bsjInput: {
                  channel: `CH${this.addLeadingZero(video.channel)}`,
                  endTime: this.formatDateToUtc(video.endTime),
                  startTime: this.formatDateToUtc(video.startTime),
                },
              }

        this.$store.commit('vehicle/setIsLoadingVideoPlayer', true)

        await this.delay(4000)

        this.$store.commit('vehicle/setIsLoadingVideoPlayer', false)

        if (!this.isUsingWsFlv) {
          const response = await this.$store.dispatch('vehicle/requestStreamFromDevice', {
            status: true,
            imei: this.vehicleDetail.imei,
            streamingEndpoint: this.$store.state.vehicle.streamingEndpoint,
            statsDataV2: {
              tvType: 'TV2',
              idRequest: uid,
            },
            ...input,
          })

          if (response.status !== 200) {
            this.$store.commit('vehicle/setVideoStatusDetail', 'noVideo')
            const responseMessage = response.message.split('"')[1]
            if (responseMessage === 'There is a playback or streaming going on') {
              return this.$mcToast.error(this.$t('videoHistory.video.playbackOrStreamingGoinOn'))
            }

            return this.$mcToast.error(this.$t('videoHistory.video.streamError'))
          }
        }

        this.$store.commit('vehicle/setIndexVideoActive', [index, indexVideo])
        this.$store.commit('vehicle/setPlaybackUidActive', uid)

        const source = {
          id: this.vehicleDetail.imei,
          startTime: video.startTime,
          src: this.getVideoHistoryUrl(
            this.vehicleDetail.deviceCode,
            this.vehicleDetail.imei,
            video.channel,
            this.$store.state.vehicle.streamingEndpoint,
            video.startTime,
            video.endTime,
            this.isUsingWsFlv
          ),
        }
        this.$store.commit('vehicle/setSource', source)
      } catch (err) {
        console.error(err)
        return this.$mcToast.error(this.$t('videoHistory.video.streamError'))
      }
    },
  },
}
</script>
